import styled from 'styled-components/native';

export const ContentContainer = styled.View`
  flex: 1;
  padding: 16px 16px 0 16px;
`;
